var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sheet',[_c('os-sheet-header',[_c('div',{staticClass:"d-flex flex-row justify-space-between align-center"},[_c('div',{staticClass:"title font-weight-regular"},[_vm._v("Create new Customer")]),_c('os-close-button',{attrs:{"to":"/customers"}})],1)]),_c('os-sheet-content',[_c('os-create-customer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }